export enum CopyItemType {
  copyAsPlaceholder = 'Copy as placeholder',
  copyWithMedia = 'Copy with media',
}

export interface CopyItemDialogChoices {
  copyType: CopyItemType,
  targetFolderId?: string,
}

export enum ClipType {
  subClip,
  virtualClip,
  singleFrame
}

export interface CreateSubClipOrVirtualClipDialogChoices {
  clipType: ClipType,
  targetFolderId?: string,
}

export interface UploadActiveSequenceDialogChoices {
  automaticallyUploadNonMimirClips: boolean;
}

export interface DialogChoices {
  copyItemDialog: CopyItemDialogChoices;
  createSubClipOrVirtualClip: CreateSubClipOrVirtualClipDialogChoices;
  uploadActiveSequenceDialog: UploadActiveSequenceDialogChoices;
}

export const defaultDialogChoices = (): DialogChoices => {
  return {
    copyItemDialog: {
      copyType: CopyItemType.copyAsPlaceholder,
    },
    createSubClipOrVirtualClip: {
      clipType: ClipType.subClip,
    },
    uploadActiveSequenceDialog: {
      automaticallyUploadNonMimirClips: false
    }
  };
};
